import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Keyboard, ViewController, Slides } from 'ionic-angular';
import { HttpServiceProvider } from '../../providers/http-service/http-service';
import { AlertProvider } from '../../providers/alert/alert';
import { ToastProvider } from '../../providers/toast/toast';
import { RequestOptions, Http, Headers } from '@angular/http';
import 'rxjs/add/operator/timeout';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GruposPage } from '../grupos/grupos';
import { Geolocation } from '@ionic-native/geolocation';

@IonicPage()
@Component({
  selector: 'page-listarcomanda',
  templateUrl: 'listarcomanda.html',
})
export class ListarcomandaPage {
  // @ViewChild('slides') slides: Slides;

  totalProdutos: any;
  total: number = 0.00;
  adicionalServico: any;
  taxaEntrega: number = 0.00;
  Cart: any[] = [];
  produtos: any[] = [];
  agruparProdutosToggle: boolean = false;
  quantidade = 1;
  formaPagamento: ""
  troco: boolean = false;
  valorTroco: string = "";
  pet: any = "entrega"
  cidadeEntrega: any = ""
  dadosEmpresa = {
    Emp_Bairro: "",
    Emp_CNPJ: "",
    Emp_Cep: "",
    Emp_Cidade: "",
    Emp_CodMunicipio: "",
    Emp_Complemento: "",
    Emp_Cor: "",
    Emp_Email: "",
    Emp_Endereco: "",
    Emp_IE: "",
    Emp_Logo: "",
    Emp_NomeFantasia: "",
    Emp_NumEndereco: "",
    Emp_Numero: "",
    Emp_RamoAtividade: "",
    Emp_RazaoSocial: "",
    Emp_Telefone: "",
    Emp_UF: "",
    Emp_WhatsApp: "",
    Emp_TempoEntrega: "",
    Emp_TempoRetirada: ""
  }

  dadosPedido = {
    nomeCliente: "",
    celularCliente: "",
    dadosPagamento: {
      formaPgto: "",
      valorTroco: 0.00,
      bandeiraCartao: ""
    },
    dadosEntrega: {
      formaTransporte: "entrega",
      Bai_Codigo: 0,
      cep: "",
      logradouro: "",
      complemento: "",
      bairro: "",
      numCasa: "",
      pontoRef: "",
      cidade: "",
      uf: ""
    },
    subTotal: 0,
    taxaEntrega: 0,
    total: 0,
    produtos: []
  }

  formularioPedido: FormGroup
  errorNomeCliente: boolean = false
  mensagemErrorNomeCliente: string = ""
  errorCelularCliente: boolean = false
  mensagemErrorCelularCliente: string = ""
  errorLogradouro: boolean = false
  mensagemErrorLogradouro: string = ""
  errorNumCasa: boolean = false
  mensagemErrorNumCasa: string = ""
  errorCidade: boolean = false
  mensagemErrorCidade: string = ""
  errorFormaPgto: boolean = false
  mensagemErrorFormaPgto: string = ""

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public httpService: HttpServiceProvider,
    public toastCtrl: ToastProvider,
    public alertCtrl: AlertProvider,
    public loadingCtrl: LoadingController,
    public http: Http,
    public keyboard: Keyboard,
    public viewCtrl: ViewController,
    public geolocationCtrl: Geolocation,
    public formBuilder: FormBuilder
  ) {
    this.formularioPedido = new FormGroup({
      nomeCliente: new FormControl('', [Validators.required]),
      celularCliente: new FormControl('', [Validators.required, Validators.minLength(11)]),
      logradouro: new FormControl('', [Validators.required]),
      numCasa: new FormControl('', [Validators.required]),
      formaPgto: new FormControl('', [Validators.required]),
    });
    this.dadosEmpresa = Object.assign({}, JSON.parse(localStorage.getItem("dadosEmpresa")))
  }

  fecharModalPedido() {
    this.viewCtrl.dismiss()
  }

  ionViewDidEnter() {
    this.Cart = JSON.parse(localStorage.getItem("NovosProdutos"))
    this.atualizarTotal()
  }

  add(i) {
    let vlrTotalComplemento = 0
    this.Cart[i].quantidade++
    this.Cart[i].complementos.forEach(item => {
      vlrTotalComplemento = vlrTotalComplemento + item.preco
    })
    this.Cart[i].vlrTotalItem = (this.Cart[i].vlrUnitario + vlrTotalComplemento) * this.Cart[i].quantidade
    this.Cart[i].vlrTotalComplementos = vlrTotalComplemento * this.Cart[i].quantidade
    this.atualizarTotal()
  }

  remove(i) {
    if (this.Cart[i].quantidade > 1) {
      let vlrTotalComplemento = 0
      this.Cart[i].quantidade = this.Cart[i].quantidade - 1
      this.Cart[i].complementos.forEach(item => {
        vlrTotalComplemento = vlrTotalComplemento + item.preco
      })
      this.Cart[i].vlrTotalItem = (this.Cart[i].vlrUnitario + vlrTotalComplemento) * this.Cart[i].quantidade
      this.Cart[i].vlrTotalComplementos = vlrTotalComplemento * this.Cart[i].quantidade
      this.atualizarTotal()
    }
  }

  deleteItem(i) {
    console.log(this.Cart)
    this.Cart.splice(i, 1)
    this.atualizarTotal()
    if (this.Cart.length == 0) {
      this.Cart = []
      this.fecharModalPedido()
    }
  }

  formataMoeda(valor) {
    return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
  }

  atualizarTotal() {
    if (this.Cart) {
      localStorage.setItem("NovosProdutos", JSON.stringify(this.Cart))
      let subTotal = 0;
      for (var i = 0; i <= this.Cart.length - 1; i++) {
        subTotal = subTotal + this.Cart[i].vlrTotalItem;
      }
      this.totalProdutos = subTotal;
      this.total = subTotal
      this.dadosPedido.subTotal = subTotal
      this.dadosPedido.total = subTotal
    }
  }

  salvarPedido() {
    let loader = this.loadingCtrl.create({
      content: "Salvando pedido, aguarde..."
    });
    loader.present();

    let carrinho = JSON.parse(localStorage.getItem("NovosProdutos"));
    let obj = {
      codUsuarioAbertura: 999,
      nroComanda: parseInt(localStorage.getItem("nroComanda")),
      produtos: carrinho
    }
    console.log("obg:", obj)
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');

    let options = new RequestOptions({ headers: headers });
    let json = JSON.stringify(obj);

    console.log(json)
    this.httpService.post(json, options).timeout(8000).toPromise().then(res => {
      this.navCtrl.setRoot(GruposPage, {nroComanda: parseInt(localStorage.getItem("nroComanda"))});
      loader.dismiss();
    }).catch(err => {
      console.log('Erro ao salvar pedido.' + err);
      this.alertCtrl.alertValidaCampos('Falha na comunicação com o servidor. Verifique a rede.', '');
      loader.dismiss();
    })
  }

  // salvarPedido() {
  //   console.log(this.dadosPedido)
  //   this.dadosPedido.produtos = JSON.parse(localStorage.getItem("NovosProdutos"))
  //   this.dadosPedido.celularCliente = this.dadosPedido.celularCliente.replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, "")
  //   this.valorTroco != "" ? this.dadosPedido.dadosPagamento.valorTroco = parseFloat(this.valorTroco) : 0.00
  //   console.log(this.dadosPedido)
  //   let loader = this.loadingCtrl.create({
  //     content: "Enviando pedido, aguarde..."
  //   });
  //   loader.present();
  //   let headers = new Headers();
  //   headers.append('Content-Type', 'application/json');
  //   headers.append('Access-Control-Allow-Origin', '*');

  //   let options = new RequestOptions({ headers: headers });
  //   this.httpService.post(JSON.stringify(this.dadosPedido), options).timeout(8000).toPromise().then(res => {
  //     loader.dismiss();
  //     if (this.dadosPedido.dadosEntrega.formaTransporte == "entrega") {
  //       this.alertCtrl.alertValidaCampos("Pedido enviado com sucesso", "Tempo para entrega de " + this.dadosEmpresa.Emp_TempoEntrega + " minutos.")
  //     } else {
  //       this.alertCtrl.alertValidaCampos("Pedido enviado com sucesso", "Tempo para retirada de " + this.dadosEmpresa.Emp_TempoRetirada + " minutos.")
  //     }
  //     this.navCtrl.setRoot(GruposPage);
  //   }).catch(err => {
  //     console.log('Erro ao salvar pedido.' + err);
  //     this.alertCtrl.alertValidaCampos('Falha na comunicação com o servidor. Verifique a rede.', '');
  //     loader.dismiss();
  //   })
  // }
}



// WEBPACK FOOTER //
// ./src/pages/listarcomanda/listarcomanda.ts